import type { TableTranslations } from './table.translations.pl.ts';

export const tableTranslations: TableTranslations = {
  pagination: {
    next: 'Suivant',
    previous: 'Précédent',
    totalPages: 'Pages',
    totalResults: 'Résultats',
    of: 'sur',
    navigation: 'Navigation entre les pages',
    rowsPerPage: 'Lignes par page :',
  },
};
